import React, { useState } from 'react';
import { 
  Search, 
  Star, 
  User, 
  Mail, 
  Calendar,
  ThumbsUp,
  ThumbsDown,
  Flag,
  CheckCircle,
  XCircle,
  Clock,
  Filter,
  ChevronDown,
  Eye,
  Edit,
  Trash2,
  MessageCircle,
  Download,
  TrendingUp,
  TrendingDown,
  Users,
  Award,
  AlertCircle
} from 'lucide-react';
import Layout from '../components/Layout';

const Reviews = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRating, setFilterRating] = useState('All');
  const [filterStatus, setFilterStatus] = useState('All');
  const [filterProduct, setFilterProduct] = useState('All');
  const [sortBy, setSortBy] = useState('newest');
  const [selectedReview, setSelectedReview] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [selectedReviews, setSelectedReviews] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const reviews = [
    {
      id: 1,
      product: 'Majun Arad Khurma',
      productId: 1,
      customer: 'Ali Khan',
      email: 'ali.khan@email.com',
      rating: 5,
      title: 'Excellent product!',
      comment: 'I have been using this for a month and I can see significant improvement in my health. Highly recommended for everyone.',
      date: '2024-04-25',
      status: 'Approved',
      helpful: 24,
      notHelpful: 2,
      images: ['/uploads/reviews/1.jpg'],
      reply: null,
      verified: true
    },
    {
      id: 2,
      product: 'Sharbat Faulad',
      productId: 2,
      customer: 'Rahim Shahk',
      email: 'rahim.shahk@email.com',
      rating: 4,
      title: 'Good quality syrup',
      comment: 'The syrup tastes good and I feel energized after taking it. Fast delivery and good packaging.',
      date: '2024-04-24',
      status: 'Approved',
      helpful: 18,
      notHelpful: 3,
      images: [],
      reply: 'Thank you for your feedback! We\'re glad you liked it.',
      verified: true
    },
    {
      id: 3,
      product: 'Habib-e-Sudanshan',
      productId: 3,
      customer: 'Sana Pathan',
      email: 'sana.pathan@email.com',
      rating: 3,
      title: 'Average product',
      comment: 'The product is okay. It works but the effects are not as dramatic as claimed. Still, it\'s good value for money.',
      date: '2024-04-23',
      status: 'Pending',
      helpful: 10,
      notHelpful: 5,
      images: [],
      reply: null,
      verified: false
    },
    {
      id: 4,
      product: 'Majun Shabab',
      productId: 4,
      customer: 'Imran Ansari',
      email: 'imran.ansari@email.com',
      rating: 5,
      title: 'Best product ever!',
      comment: 'This is truly amazing. I have recommended it to all my family members. Will definitely buy again.',
      date: '2024-04-22',
      status: 'Approved',
      helpful: 42,
      notHelpful: 1,
      images: ['/uploads/reviews/4-1.jpg', '/uploads/reviews/4-2.jpg'],
      reply: 'Thank you so much for your wonderful review!',
      verified: true
    },
    {
      id: 5,
      product: 'Rogan Badam',
      productId: 5,
      customer: 'Faisal Memon',
      email: 'faisal.memon@email.com',
      rating: 2,
      title: 'Not satisfied',
      comment: 'The product didn\'t work for me. I followed all instructions but didn\'t see any noticeable results.',
      date: '2024-04-21',
      status: 'Rejected',
      helpful: 5,
      notHelpful: 8,
      images: [],
      reply: null,
      verified: false
    },
    {
      id: 6,
      product: 'Khamira Abresham',
      productId: 6,
      customer: 'Zainab Ahmed',
      email: 'zainab.ahmed@email.com',
      rating: 4,
      title: 'Good product',
      comment: 'Very good product. I have been using it for 2 weeks and I can see positive changes. Will recommend.',
      date: '2024-04-20',
      status: 'Approved',
      helpful: 15,
      notHelpful: 2,
      images: [],
      reply: 'Thank you for your review. We appreciate your feedback.',
      verified: true
    },
    {
      id: 7,
      product: 'Majun Arad Khurma',
      productId: 1,
      customer: 'Omar Farooq',
      email: 'omar.farooq@email.com',
      rating: 5,
      title: 'Amazing results!',
      comment: 'I\'m blown away by the results. This product has changed my life completely. 5 stars!',
      date: '2024-04-19',
      status: 'Approved',
      helpful: 56,
      notHelpful: 3,
      images: ['/uploads/reviews/7.jpg'],
      reply: 'We\'re so happy to hear this! Thank you for sharing your experience.',
      verified: true
    },
    {
      id: 8,
      product: 'Sharbat Faulad',
      productId: 2,
      customer: 'Fatima Sheikh',
      email: 'fatima.sheikh@email.com',
      rating: 3,
      title: 'Decent product',
      comment: 'It\'s a decent product but I expected more. The taste is good but the effects are mild.',
      date: '2024-04-18',
      status: 'Pending',
      helpful: 8,
      notHelpful: 4,
      images: [],
      reply: null,
      verified: false
    },
    {
      id: 9,
      product: 'Habib-e-Sudanshan',
      productId: 3,
      customer: 'Hassan Ali',
      email: 'hassan.ali@email.com',
      rating: 4,
      title: 'Good value',
      comment: 'Good product for the price. It works well and the quality is consistent.',
      date: '2024-04-17',
      status: 'Approved',
      helpful: 12,
      notHelpful: 1,
      images: [],
      reply: 'Thank you for your honest review!',
      verified: true
    },
    {
      id: 10,
      product: 'Majun Shabab',
      productId: 4,
      customer: 'Aisha Khan',
      email: 'aisha.khan@email.com',
      rating: 1,
      title: 'Terrible experience',
      comment: 'Waste of money. The product caused side effects and I had to stop using it. Very disappointed.',
      date: '2024-04-16',
      status: 'Rejected',
      helpful: 3,
      notHelpful: 15,
      images: [],
      reply: null,
      verified: false
    }
  ];

  const productOptions = ['All', 'Majun Arad Khurma', 'Sharbat Faulad', 'Habib-e-Sudanshan', 'Majun Shabab', 'Rogan Badam', 'Khamira Abresham'];
  const statusOptions = ['All', 'Approved', 'Pending', 'Rejected'];
  const ratingOptions = ['All', '5 Stars', '4 Stars', '3 Stars', '2 Stars', '1 Star'];

  const getStatusBadge = (status) => {
    const classes = {
      'Approved': 'badge-success',
      'Pending': 'badge-warning',
      'Rejected': 'badge-danger'
    };
    return classes[status] || 'badge-info';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'Approved': <CheckCircle size={14} />,
      'Pending': <Clock size={14} />,
      'Rejected': <XCircle size={14} />
    };
    return icons[status] || <AlertCircle size={14} />;
  };

  const renderStars = (rating, size = 16) => {
    return (
      <div className="stars">
        {[1, 2, 3, 4, 5].map(star => (
          <Star 
            key={star} 
            size={size} 
            className={star <= rating ? 'filled' : 'empty'}
          />
        ))}
      </div>
    );
  };

  // Filter reviews
  const filteredReviews = reviews.filter(review => {
    const matchesSearch = 
      review.product.toLowerCase().includes(searchTerm.toLowerCase()) ||
      review.customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
      review.comment.toLowerCase().includes(searchTerm.toLowerCase()) ||
      review.title.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesRating = filterRating === 'All' || review.rating === parseInt(filterRating);
    const matchesStatus = filterStatus === 'All' || review.status === filterStatus;
    const matchesProduct = filterProduct === 'All' || review.product === filterProduct;
    
    return matchesSearch && matchesRating && matchesStatus && matchesProduct;
  });

  // Sort reviews
  const sortedReviews = [...filteredReviews].sort((a, b) => {
    if (sortBy === 'newest') {
      return new Date(b.date) - new Date(a.date);
    } else if (sortBy === 'oldest') {
      return new Date(a.date) - new Date(b.date);
    } else if (sortBy === 'highest') {
      return b.rating - a.rating;
    } else if (sortBy === 'lowest') {
      return a.rating - b.rating;
    } else if (sortBy === 'helpful') {
      return b.helpful - a.helpful;
    }
    return 0;
  });

  // Stats
  const stats = {
    total: reviews.length,
    approved: reviews.filter(r => r.status === 'Approved').length,
    pending: reviews.filter(r => r.status === 'Pending').length,
    rejected: reviews.filter(r => r.status === 'Rejected').length,
    averageRating: (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1),
    totalHelpful: reviews.reduce((sum, r) => sum + r.helpful, 0)
  };

  // Rating distribution
  const ratingDistribution = {
    5: reviews.filter(r => r.rating === 5).length,
    4: reviews.filter(r => r.rating === 4).length,
    3: reviews.filter(r => r.rating === 3).length,
    2: reviews.filter(r => r.rating === 2).length,
    1: reviews.filter(r => r.rating === 1).length
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedReviews([]);
    } else {
      setSelectedReviews(sortedReviews.map(r => r.id));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectReview = (id) => {
    if (selectedReviews.includes(id)) {
      setSelectedReviews(selectedReviews.filter(r => r.id !== id));
    } else {
      setSelectedReviews([...selectedReviews, id]);
    }
  };

  const handleViewReview = (review) => {
    setSelectedReview(review);
    setShowReviewModal(true);
  };

  const handleStatusChange = (id, newStatus) => {
    console.log(`Review ${id} status changed to ${newStatus}`);
  };

  const handleDeleteReview = (id) => {
    if (window.confirm('Are you sure you want to delete this review?')) {
      console.log(`Delete review ${id}`);
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <Layout>
      <div className="reviews-page">
        {/* Page Header */}
        <div className="page-header">
          <div>
            <h1 className="page-title">Reviews</h1>
            <p className="page-subtitle">Manage customer reviews and ratings</p>
          </div>
          <div className="page-actions">
            <button className="btn btn-outline btn-sm">
              <Download size={16} />
              Export
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="reviews-stats">
          <div className="stat-item">
            <div className="stat-icon" style={{ background: 'var(--color-primary)' }}>
              <Star size={20} />
            </div>
            <div>
              <span className="stat-label">Average Rating</span>
              <span className="stat-value">{stats.averageRating}</span>
            </div>
            <div className="stat-stars">{renderStars(Math.round(stats.averageRating), 14)}</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon" style={{ background: 'var(--color-success)' }}>
              <CheckCircle size={20} />
            </div>
            <div>
              <span className="stat-label">Approved</span>
              <span className="stat-value">{stats.approved}</span>
            </div>
            <span className="stat-change up">+12%</span>
          </div>
          <div className="stat-item">
            <div className="stat-icon" style={{ background: 'var(--color-warning)' }}>
              <Clock size={20} />
            </div>
            <div>
              <span className="stat-label">Pending</span>
              <span className="stat-value">{stats.pending}</span>
            </div>
            <span className="stat-change down">-3%</span>
          </div>
          <div className="stat-item">
            <div className="stat-icon" style={{ background: 'var(--color-danger)' }}>
              <XCircle size={20} />
            </div>
            <div>
              <span className="stat-label">Rejected</span>
              <span className="stat-value">{stats.rejected}</span>
            </div>
            <span className="stat-change down">-1%</span>
          </div>
        </div>

        {/* Rating Distribution */}
        <div className="rating-distribution card">
          <h4 className="distribution-title">Rating Distribution</h4>
          <div className="distribution-bars">
            {[5, 4, 3, 2, 1].map(rating => {
              const count = ratingDistribution[rating];
              const percentage = (count / reviews.length) * 100;
              return (
                <div key={rating} className="distribution-row">
                  <span className="distribution-label">
                    {rating} <Star size={12} className="filled" />
                  </span>
                  <div className="distribution-bar">
                    <div 
                      className="distribution-fill" 
                      style={{ 
                        width: `${percentage}%`,
                        background: rating >= 4 ? 'var(--color-success)' : 
                                  rating >= 3 ? 'var(--color-warning)' : 
                                  'var(--color-danger)'
                      }}
                    />
                  </div>
                  <span className="distribution-count">{count}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Filters */}
        <div className="reviews-filters card">
          <div className="filter-row">
            <div className="filter-group">
              <div className="search-box">
                <Search size={18} className="search-icon" />
                <input
                  type="text"
                  placeholder="Search reviews by product, customer, or comment..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                {searchTerm && (
                  <button className="clear-search" onClick={() => setSearchTerm('')}>
                    ✕
                  </button>
                )}
              </div>
            </div>

            <div className="filter-group">
              <select 
                className="filter-select"
                value={filterRating}
                onChange={(e) => setFilterRating(e.target.value)}
              >
                {ratingOptions.map(option => (
                  <option key={option} value={option === 'All' ? 'All' : option.split(' ')[0]}>
                    {option}
                  </option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                {statusOptions.map(status => (
                  <option key={status} value={status}>
                    {status === 'All' ? 'All Status' : status}
                  </option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={filterProduct}
                onChange={(e) => setFilterProduct(e.target.value)}
              >
                {productOptions.map(product => (
                  <option key={product} value={product}>
                    {product === 'All' ? 'All Products' : product}
                  </option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="newest">Newest First</option>
                <option value="oldest">Oldest First</option>
                <option value="highest">Highest Rating</option>
                <option value="lowest">Lowest Rating</option>
                <option value="helpful">Most Helpful</option>
              </select>
            </div>
          </div>
        </div>

        {/* Reviews Table */}
        <div className="card reviews-table-container">
          <div className="table-container">
            <table className="table reviews-table">
              <thead>
                <tr>
                  <th style={{ width: '40px' }}>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="checkbox"
                    />
                  </th>
                  <th>Product</th>
                  <th>Customer</th>
                  <th>Rating</th>
                  <th>Review</th>
                  <th>Date</th>
                  <th>Helpful</th>
                  <th>Status</th>
                  <th style={{ width: '120px' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedReviews.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="empty-state">
                      <div className="empty-state-content">
                        <span className="empty-icon">⭐</span>
                        <h3>No reviews found</h3>
                        <p>Try adjusting your search or filter criteria</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  sortedReviews.map((review) => (
                    <tr key={review.id} className="review-row">
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedReviews.includes(review.id)}
                          onChange={() => handleSelectReview(review.id)}
                          className="checkbox"
                        />
                      </td>
                      <td>
                        <span className="review-product">{review.product}</span>
                      </td>
                      <td>
                        <div className="reviewer-info">
                          <div className="reviewer-avatar">
                            {review.customer.charAt(0)}
                          </div>
                          <div>
                            <div className="reviewer-name">{review.customer}</div>
                            <div className="reviewer-email">{review.email}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="review-rating">
                          {renderStars(review.rating, 14)}
                          <span className="rating-number">{review.rating}.0</span>
                        </div>
                      </td>
                      <td>
                        <div className="review-content">
                          <div className="review-title">{review.title}</div>
                          <div className="review-comment">
                            {review.comment.length > 60 
                              ? review.comment.substring(0, 60) + '...' 
                              : review.comment}
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="review-date">{formatDate(review.date)}</span>
                      </td>
                      <td>
                        <div className="helpful-count">
                          <ThumbsUp size={12} />
                          <span>{review.helpful}</span>
                        </div>
                      </td>
                      <td>
                        <div className="status-select-wrapper">
                          <select
                            className={`status-select ${review.status.toLowerCase()}`}
                            value={review.status}
                            onChange={(e) => handleStatusChange(review.id, e.target.value)}
                          >
                            {statusOptions.filter(s => s !== 'All').map(status => (
                              <option key={status} value={status}>
                                {status}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button 
                            className="btn btn-sm btn-outline"
                            onClick={() => handleViewReview(review)}
                            title="View Review"
                          >
                            <Eye size={16} />
                          </button>
                          <button 
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeleteReview(review.id)}
                            title="Delete Review"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Table Footer */}
          <div className="table-footer">
            <div className="table-info">
              {selectedReviews.length > 0 ? (
                <span>
                  {selectedReviews.length} reviews selected
                  <button className="btn btn-sm btn-outline ml-sm">
                    Bulk Action <ChevronDown size={14} />
                  </button>
                </span>
              ) : (
                <span>Showing {sortedReviews.length} of {reviews.length} reviews</span>
              )}
            </div>
            <div className="pagination">
              <button className="btn btn-sm btn-outline">Previous</button>
              <button className="btn btn-sm btn-primary active">1</button>
              <button className="btn btn-sm btn-outline">2</button>
              <button className="btn btn-sm btn-outline">3</button>
              <span className="pagination-ellipsis">...</span>
              <button className="btn btn-sm btn-outline">10</button>
              <button className="btn btn-sm btn-outline">Next</button>
            </div>
          </div>
        </div>
      </div>

      {/* Review Detail Modal */}
      {showReviewModal && selectedReview && (
        <div className="modal-overlay" onClick={() => setShowReviewModal(false)}>
          <div className="modal review-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-review-info">
                <div className="modal-rating">
                  {renderStars(selectedReview.rating, 20)}
                  <span className="modal-rating-number">{selectedReview.rating}.0</span>
                </div>
                <h2 className="modal-title">{selectedReview.title}</h2>
                <p className="modal-subtitle">
                  {selectedReview.product} • {formatDate(selectedReview.date)}
                </p>
              </div>
              <button 
                className="modal-close"
                onClick={() => setShowReviewModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="review-modal-content">
              {/* Review Status */}
              <div className="review-status-section">
                <span className={`badge ${getStatusBadge(selectedReview.status)}`}>
                  {getStatusIcon(selectedReview.status)}
                  {selectedReview.status}
                </span>
                {selectedReview.verified && (
                  <span className="badge badge-info">
                    <CheckCircle size={12} />
                    Verified Purchase
                  </span>
                )}
              </div>

              {/* Reviewer Info */}
              <div className="reviewer-details">
                <div className="reviewer-info-large">
                  <div className="reviewer-avatar-large">
                    {selectedReview.customer.charAt(0)}
                  </div>
                  <div>
                    <div className="reviewer-name-large">{selectedReview.customer}</div>
                    <div className="reviewer-email-large">{selectedReview.email}</div>
                  </div>
                </div>
              </div>

              {/* Review Content */}
              <div className="review-full-content">
                <p className="review-full-comment">{selectedReview.comment}</p>
                
                {selectedReview.images && selectedReview.images.length > 0 && (
                  <div className="review-images">
                    {selectedReview.images.map((img, index) => (
                      <div key={index} className="review-image">
                        <img src={img} alt={`Review ${index + 1}`} />
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Helpful Stats */}
              <div className="review-helpful-stats">
                <div className="helpful-stat">
                  <ThumbsUp size={16} />
                  <span>{selectedReview.helpful} people found this helpful</span>
                </div>
                <div className="helpful-stat">
                  <ThumbsDown size={16} />
                  <span>{selectedReview.notHelpful} people found this not helpful</span>
                </div>
              </div>

              {/* Admin Reply */}
              {selectedReview.reply && (
                <div className="review-reply">
                  <div className="reply-header">
                    <MessageCircle size={16} />
                    <span>Admin Reply</span>
                  </div>
                  <p className="reply-content">{selectedReview.reply}</p>
                </div>
              )}

              {/* Admin Actions */}
              <div className="review-admin-actions">
                <select 
                  className="filter-select"
                  value={selectedReview.status}
                  onChange={(e) => handleStatusChange(selectedReview.id, e.target.value)}
                >
                  {statusOptions.filter(s => s !== 'All').map(status => (
                    <option key={status} value={status}>{status}</option>
                  ))}
                </select>
                <button className="btn btn-primary">
                  <MessageCircle size={16} />
                  Reply to Review
                </button>
                <button className="btn btn-danger">
                  <Trash2 size={16} />
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Reviews;